import { render, staticRenderFns } from "./VerificationBadge.vue?vue&type=template&id=07f15536&scoped=true"
import script from "./VerificationBadge.vue?vue&type=script&lang=js"
export * from "./VerificationBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f15536",
  null
  
)

export default component.exports